import { dexQuery } from '@/helpers/graphql';
import { getArticleInfoById } from '@/store/queries/dexQueries';
import { ContentsType } from '@/models/undergrad/services/dex.services.model';

export class DexArticleService {
  static async getDexArticleInfo(id: number): Promise<ContentsType[]> {
    const articleId = parseInt(String(id), 10);
    const {
      data: {
        articleById: { contentsByArticleIdList },
      },
    } = await dexQuery(getArticleInfoById, { articleId });

    return (contentsByArticleIdList as ContentsType[]).sort((a, b) => a.position - b.position);
  }
}
